// extracted by mini-css-extract-plugin
module.exports = {"custom":"YellowBtn_custom__2fxZw"};